import { axiosInstance as axios } from "services";

export const updateStandardStatements = async (id, data) => {
  const { data: res } = await axios.patch(`/admin/standardStatementsMaster/${id}`, data);
  if (!res.success) throw new Error(res.error || "Failed to update standard statement");
  return res;
};

